import { isFeatureEnabled } from 'owa-feature-flags';
import { isSharePointLink } from 'owa-sharepoint-link-detector';
import { trace } from 'owa-trace';
import LinkPlugin from '../plugin/LinkPlugin';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { AnchorElementsSource } from '../types/AnchorElementsSource';
import { DIV_TAG_NAME } from './constants';
import { getSharingInfoToTryUpdateLink } from './handleOneLink/getSharingInfoToTryUpdateLink';
import trySetIdAndClassName from './trySetIdAndClassName';

export function shareLinkComposeHandling(
    linkPlugin: LinkPlugin,
    linkIdContainer: LinkIdContainer,
    linkIdsWithSpinner: string[]
): boolean {
    if (!isFeatureEnabled('doc-link-shareCompose')) {
        return false;
    }

    const allDivs: HTMLDivElement[] = linkPlugin.editor.queryElements(DIV_TAG_NAME);
    if (allDivs.length === 1) {
        // Office Online clients (Word or PowerPoint) share link compose
        // The compose body will only have one div element containing the OneDrive link url text
        trace.info('shareLinkComposeHandling: only one div element');
        const divInnerHTML = allDivs[0].innerHTML;
        if (
            allDivs[0].childElementCount === 0 &&
            isSharePointLink(divInnerHTML) &&
            divInnerHTML.indexOf(' ') === -1
        ) {
            const newAnchor: HTMLAnchorElement = document.createElement('a');
            newAnchor.href = divInnerHTML;
            newAnchor.innerText = divInnerHTML;
            trySetIdAndClassName(newAnchor, false);
            linkPlugin.editor.deleteNode(allDivs[0]);
            linkPlugin.editor.insertNode(newAnchor);

            getSharingInfoToTryUpdateLink(
                linkPlugin,
                true /* shouldBeautify */,
                false /* shouldRehydrate */,
                false /* isLinkPreviouslyBeautified */,
                newAnchor,
                linkIdContainer,
                0 /* linkIndex */,
                linkIdsWithSpinner,
                AnchorElementsSource.ShareLinkCompose
            );

            return true; // No need to continue the other process as this editor only contains the text of one link url
        }
    }

    return false;
}
